import React from 'react';
import { HotelTile } from './HotelTile';
import { Divider } from '@withjoy/joykit';
import { useLayout } from '../../layouts/LayoutProvider';

interface HotelTileData {
  foo: string;
  bar: string;
}
interface HotelTileListProps {
  hotelTileListData: HotelTileData[];
}

const HotelTileList: React.FC<HotelTileListProps> = ({ hotelTileListData }) => {
  const { layout } = useLayout();
  const isAloha = layout === 'aloha';
  const isBrannan = layout === 'brannan';
  return (
    <>
      {hotelTileListData.map((hotel, idx) => {
        return (
          <>
            {isAloha && <Divider />}
            <HotelTile />
            {idx < hotelTileListData.length - 1 && <Divider marginBottom={isBrannan ? { _: 0, sm2: 8 } : 0} />}
          </>
        );
      })}
    </>
  );
};

HotelTileList.displayName = 'HotelTileList';

export { HotelTileList };
